import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdTreadAgentSkills } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useMemo } from 'react';

import { TreadAgentSkillBasic } from '~hooks/useTreadAgent/models';
import { TREAD_AGENT_SKILLS_QUERY_KEY } from '~queries/treadAgentQueryKeys';
import connection from '~services/connectionModule';
import { Nullable } from '~types/Nullable';

export default function useTreadAgentSkillsQuery(companyId: Nullable<string>) {
  const query = useQuery({
    queryKey: [TREAD_AGENT_SKILLS_QUERY_KEY, companyId],
    queryFn: companyId
      ? async ({ signal }) => {
          try {
            const response = await getV1CompaniesCompanyIdTreadAgentSkills({
              path: { 'company-id': companyId },
              signal,
            });
            return response.data.data.map(TreadAgentSkillBasic.parse);
          } catch (error) {
            connection.handleRequestError(
              error,
              t('error_messages.tread_agent.failed_to_fetch_skills'),
            );
            throw error;
          }
        }
      : skipToken,
    gcTime: Infinity,
    refetchOnMount: 'always',
    staleTime: Infinity,
  });

  const skills = useMemo(() => query.data ?? [], [query.data]);

  return { isLoading: query.isLoading, skills };
}
